module.exports = __webpack_public_path__ + "static/2020-ruby-on-rails-survey-results-91ad6eb44db313d164f937efb21b1fae.png";